"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = require("react");
var useWidgetContext_1 = require("../../react/useWidgetContext");
var myAccount_1 = require("../../constants/myAccount");
var assetManager_1 = require("../../../../../common/service/assetManager");
var constants_1 = require("../../constants/constants");
var errorHandler_1 = require("../../service/errorHandler");
var MinimalLoader_1 = require("../presentation/MinimalLoader/MinimalLoader");
var MyAccountDisplayMode_1 = require("../../enum/MyAccountDisplayMode");
var MyAccountMiniDxp = function (_a) {
    var _b = _a.loginInModal, loginInModal = _b === void 0 ? false : _b, _c = _a.displayMode, displayMode = _c === void 0 ? MyAccountDisplayMode_1.MyAccountDisplayMode.LOGIN_BUTTON : _c, dealId = _a.dealId, dataTest = _a["data-test"], introducedEmail = _a.introducedEmail, shouldProceedFlow = _a.shouldProceedFlow;
    var widgetId = react_1.useMemo(function () { return 'dxp-myaccount-mini-container' + Math.floor(Math.random() * 100); }, [
        loginInModal,
        displayMode,
        dealId,
    ]);
    var widgetInstance = react_1.useRef(null);
    var myAccountLibrary = react_1.useRef(null);
    var configuration = useWidgetContext_1.default().configuration;
    var _d = react_1.useState(false), isLoading = _d[0], setLoadingStatus = _d[1];
    var ensureLibraryLoaded = function () {
        var widgetUrl = myAccount_1.MY_ACCOUNT_CONFIG.dxpWidgetUrl;
        if (assetManager_1.assetManager.isScriptLoaded(widgetUrl)) {
            if (!myAccountLibrary.current && window.DXPMyAccount) {
                myAccountLibrary.current = window.DXPMyAccount;
            }
            return Promise.resolve();
        }
        return Promise.resolve()
            .then(function () {
            // keep in mind there's a slight difference between the react versions of dxp and auto-widgets
            if (!assetManager_1.assetManager.isScriptLoaded(constants_1.default.REACT_DEPENDENCIES.react18)) {
                return assetManager_1.assetManager
                    .loadScript(constants_1.default.REACT_DEPENDENCIES.react18)
                    .then(function () { return assetManager_1.assetManager.loadScript(constants_1.default.REACT_DEPENDENCIES.reactDom18); });
            }
        })
            .then(function () { return assetManager_1.assetManager.loadScript(widgetUrl, 'module'); })
            .then(function () {
            myAccountLibrary.current = window.DXPMyAccount;
        });
    };
    var getLibrary = react_1.useCallback(function () {
        if (!myAccountLibrary.current) {
            throw new Error("Attempted to use DXP MyAccount library without loading it first");
        }
        return myAccountLibrary.current;
    }, [myAccountLibrary.current]);
    var initializeWidget = function () {
        if (widgetInstance.current) {
            widgetInstance.current.destroy();
        }
        setLoadingStatus(true);
        var widgetConfig = __assign(__assign(__assign({ containerId: widgetId, dimensions: configuration.dimensions, cookieDomain: process.env.REACT_APP_SESSION_COOKIE_DOMAIN, loginInModal: loginInModal,
            displayMode: displayMode,
            dealId: dealId }, (shouldProceedFlow && {
            activeTab: shouldProceedFlow,
        })), (introducedEmail && {
            introducedEmail: introducedEmail,
        })), { myAccountUrl: configuration.myAccountUrl });
        if (configuration.cookieDomain) {
            widgetConfig.cookieDomain = configuration.cookieDomain;
        }
        var dxpWidget = getLibrary();
        dxpWidget.createMiniWidget(widgetConfig);
    };
    react_1.useEffect(function () {
        if (!widgetInstance.current) {
            ensureLibraryLoaded()
                .then(function () { return initializeWidget(); })
                .catch(errorHandler_1.default.promise())
                .finally(function () { return setLoadingStatus(false); });
        }
        return function () {
            if (widgetInstance.current) {
                widgetInstance.current.destroy();
            }
        };
    }, []);
    return (<>
      {isLoading && <MinimalLoader_1.default />}
      <div id={widgetId} data-test={dataTest}/>
    </>);
};
exports.default = MyAccountMiniDxp;
